module.exports = __webpack_public_path__ + "static/media/projectmanagement.ad322325.jpg";